import Vue from 'vue'

const mockiOApi = function(ctx) {
  return {
    getCustomerInfo: (url) => {
      const currentInstallation = ctx.$storage.getUniversal(
        'current-installation'
      )
      const mockData = {
        success: true,
        customer: {
          id: '123456789',
          firstName: 'John',
          lastName: 'Doe',
          email: 'john.doe@gmail.com',
          address: {
            street: 'JohnStreet',
            number: 42,
            box: null,
            postalCode: '65535',
            city: 'Location',
            country: 'BE'
          },
          requireBuildingFinishDate: true
        },
        installations: [
          {
            id: null,
            status: 'commissioned', // "installed" || "commissioned" || "registered" || "incomplete" || "unlinked"
            customerId: null,
            customerEmail: 'j*****.d***@i***.com',
            productRange: {
              id: 'b932a2dc-75aa-4534-a72b-eeb56c6975d3',
              name:
                'Daikin Altherma air/water heatpump low temperature wallhung',
              imageUrl:
                'https://stage.static.daikin.marlon.be/uploads/images/catalog/product-range/e650e2b2-61e5-11e5-8dc8-005056981398/f4a0c338f5fce8d1458c56f8f3daf07f0eebccfd.jpg',
              category: '',
              categoryImageUrl: 'https://...'
            },
            siteId: '',
            commissioningCode: 'ABC3',
            installationDate: '2024-11-01',
            buildingDate: '2022-11-01',
            servicePartner: {
              id: 'string',
              email: 'climatronix@partner.com',
              company_name: 'ClimaTronix bvba',
              full_name: 'ClimaTronix',
              website_url: 'string',
              address: {
                street: 'Honderedweg',
                number: '10',
                postal_code: '9230',
                city: 'Wetteren',
                country: 'België'
              },
              phone_number: 'string'
            },
            address: {
              street: 'JohnStreet',
              number: 42,
              box: null,
              postalCode: '65535',
              city: 'Location',
              country: 'BE'
            },
            units: [
              {
                type: 'lan_adapter',
                material: 'abc123',
                serial: '9876543',
                registeredOnSbm: false
              },
              {
                type: 'indoor',
                material: '000000',
                serial: '12345678',
                registeredOnSbm: false
              }
            ]
          },
          {
            id: null,
            status: 'commissioned', // "installed" || "commissioned" || "registered" || "incomplete" || "unlinked"
            customerId: null,
            customerEmail: 'j*****.d***@i***.com',
            productRange: {
              id: 'b932a2dc-75aa-4534-a72b-eeb56c6975d3',
              name:
                'Daikin Altherma air/water heatpump low temperature wallhung',
              imageUrl:
                'https://stage.static.daikin.marlon.be/uploads/images/catalog/product-range/e650e2b2-61e5-11e5-8dc8-005056981398/f4a0c338f5fce8d1458c56f8f3daf07f0eebccfd.jpg',
              category: '',
              categoryImageUrl: 'https://...'
            },
            siteId: '',
            commissioningCode: 'ABC3',
            installationDate: '2024-11-01',
            buildingDate: '2022-11-01',
            servicePartner: {
              id: 'string',
              email: 'climatronix@partner.com',
              company_name: 'ClimaTronix bvba',
              full_name: 'ClimaTronix',
              website_url: 'string',
              address: {
                street: 'Honderedweg',
                number: '10',
                postal_code: '9230',
                city: 'Wetteren',
                country: 'België'
              },
              phone_number: 'string'
            },
            address: {
              street: 'JohnStreet',
              number: 42,
              box: null,
              postalCode: '65535',
              city: 'Location',
              country: 'BE'
            },
            units: [
              {
                type: 'lan_adapter',
                material: 'abc123',
                serial: '9876543',
                registeredOnSbm: false
              },
              {
                type: 'indoor',
                material: '000000',
                serial: '12345678',
                registeredOnSbm: false
              }
            ]
          },
          {
            id: null,
            status: 'commissioned', // "installed" || "commissioned" || "registered" || "incomplete" || "unlinked"
            customerId: null,
            customerEmail: 'j*****.d***@i***.com',
            productRange: {
              id: null,
              name: null,
              imageUrl: null,
              category: 'Altherma product category',
              categoryImageUrl:
                'https://stage.static.daikin.marlon.be/uploads/images/catalog/product-range/e650e2b2-61e5-11e5-8dc8-005056981398/f4a0c338f5fce8d1458c56f8f3daf07f0eebccfd.jpg'
            },
            siteId: '',
            commissioningCode: 'ABC3',
            installationDate: '2024-11-01',
            buildingDate: '2022-11-01',
            servicePartner: {
              id: 'string',
              email: 'climatronix@partner.com',
              company_name: 'ClimaTronix bvba',
              full_name: 'ClimaTronix',
              website_url: 'string',
              address: {
                street: 'Honderedweg',
                number: '10',
                postal_code: '9230',
                city: 'Wetteren',
                country: 'België'
              },
              phone_number: 'string'
            },
            address: {
              street: 'JohnStreet',
              number: 42,
              box: null,
              postalCode: '65535',
              city: 'Location',
              country: 'BE'
            },
            units: [
              {
                type: 'indoor',
                material: 'CVXM20A3V1B',
                serial: 'AALTRA123',
                registeredOnSbm: false
              },
              {
                type: 'outdoor',
                material: '2MXM40M4V1B',
                serial: 'AALTRA456',
                registeredOnSbm: false
              }
            ]
          },
          {
            id: null,
            status: 'commissioned', // "installed" || "commissioned" || "registered" || "incomplete" || "unlinked"
            customerId: null,
            customerEmail: 'j*****.d***@i***.com',
            productRange: {
              id: null,
              name: null,
              imageUrl: null,
              category: 'Altherma product category',
              categoryImageUrl:
                'https://stage.static.daikin.marlon.be/uploads/images/catalog/product-range/e650e2b2-61e5-11e5-8dc8-005056981398/f4a0c338f5fce8d1458c56f8f3daf07f0eebccfd.jpg'
            },
            siteId: '',
            commissioningCode: 'ABC3',
            installationDate: '2024-11-01',
            buildingDate: '2022-11-01',
            servicePartner: {
              id: 'string',
              email: 'climatronix@partner.com',
              company_name: 'ClimaTronix bvba',
              full_name: 'ClimaTronix',
              website_url: 'string',
              address: {
                street: 'Honderedweg',
                number: '10',
                postal_code: '9230',
                city: 'Wetteren',
                country: 'België'
              },
              phone_number: 'string'
            },
            address: {
              street: 'JohnStreet',
              number: 42,
              box: null,
              postalCode: '65535',
              city: 'Location',
              country: 'BE'
            },
            units: [
              {
                type: 'indoor',
                material: 'CVXM20A3V1B9',
                serial: '12345678',
                registeredOnSbm: false
              }
            ]
          },
          {
            id: null,
            status: 'commissioned', // "installed" || "commissioned" || "registered" || "incomplete" || "unlinked"
            customerId: null,
            customerEmail: 'j*****.d***@i***.com',
            productRange: {
              id: null,
              name: null,
              imageUrl: null,
              category: 'No product range / category',
              categoryImageUrl: null
            },
            siteId: '',
            commissioningCode: 'ABC3',
            installationDate: '2024-11-01',
            buildingDate: '2022-11-01',
            servicePartner: {
              id: 'string',
              email: 'climatronix@partner.com',
              company_name: 'ClimaTronix bvba',
              full_name: 'ClimaTronix',
              website_url: 'string',
              address: {
                street: 'Honderedweg',
                number: '10',
                postal_code: '9230',
                city: 'Wetteren',
                country: 'België'
              },
              phone_number: 'string'
            },
            address: {
              street: 'JohnStreet',
              number: 42,
              box: null,
              postalCode: '65535',
              city: 'Location',
              country: 'BE'
            },
            units: [
              {
                type: 'indoor',
                material: 'CVXM20A3V1B9',
                serial: '12345678',
                registeredOnSbm: false
              }
            ]
          },
          {
            id: currentInstallation?.id,
            status: 'registered', // "installed" || "commissioned" || "registered" || "incomplete" || "unlinked"
            customerId: '123456789',
            customerEmail: 'j*****.d***@i***.com',
            productRange: {
              id: 'b932a2dc-75aa-4534-a72b-eeb56c6975d3',
              name:
                'Daikin Altherma air/water heatpump low temperature wallhung',
              imageUrl:
                'https://stage.static.daikin.marlon.be/uploads/images/catalog/product-range/e650e2b2-61e5-11e5-8dc8-005056981398/f4a0c338f5fce8d1458c56f8f3daf07f0eebccfd.jpg',
              category: '',
              categoryImageUrl: 'https://...'
            },
            siteId: '',
            commissioningCode: 'ABC3',
            installationDate: '2024-11-01',
            buildingDate: '2022-11-01',
            servicePartner: {
              id: 'string',
              email: 'user@example.com',
              company_name: 'string',
              full_name: 'string',
              website_url: 'string',
              address: {
                street: 'string',
                number: 'string',
                postal_code: 'string',
                city: 'string',
                country: 'string'
              },
              phone_number: 'string'
            },
            address: {
              street: 'JohnStreet',
              number: 42,
              box: null,
              postalCode: '65535',
              city: 'Location',
              country: 'BE'
            },
            units: [
              {
                type: 'lan_adapter',
                material: 'abc123456',
                serial: '6876543',
                registeredOnSbm: false
              },
              {
                type: 'indoor',
                material: '000000',
                serial: '62345678',
                registeredOnSbm: true
              },
              {
                type: 'outdoor',
                material: '000000',
                serial: '12345678',
                registeredOnSbm: true
              }
            ]
          },
          {
            id: currentInstallation?.id,
            status: 'registered', // "installed" || "commissioned" || "registered" || "incomplete" || "unlinked"
            customerId: 'not-yours',
            customerEmail: 'j*****.d***@i***.com',
            productRange: {
              id: 'b932a2dc-75aa-4534-a72b-eeb56c6975d3',
              name:
                'Daikin Altherma air/water heatpump low temperature wallhung',
              imageUrl:
                'https://stage.static.daikin.marlon.be/uploads/images/catalog/product-range/e650e2b2-61e5-11e5-8dc8-005056981398/f4a0c338f5fce8d1458c56f8f3daf07f0eebccfd.jpg',
              category: '',
              categoryImageUrl: 'https://...'
            },
            siteId: '',
            commissioningCode: 'ABC3',
            installationDate: '2024-11-01',
            buildingDate: '2022-11-01',
            servicePartner: {
              id: 'string',
              email: 'user@example.com',
              company_name: 'string',
              full_name: 'string',
              website_url: 'string',
              address: {
                street: 'string',
                number: 'string',
                postal_code: 'string',
                city: 'string',
                country: 'string'
              },
              phone_number: 'string'
            },
            address: {
              street: 'JohnStreet',
              number: 42,
              box: null,
              postalCode: '65535',
              city: 'Location',
              country: 'BE'
            },
            units: [
              {
                type: 'lan_adapter',
                material: 'abc123456',
                serial: '6876543',
                registeredOnSbm: false
              },
              {
                type: 'indoor',
                material: '000000',
                serial: '62345678',
                registeredOnSbm: true
              },
              {
                type: 'outdoor',
                material: '000000',
                serial: '12345678',
                registeredOnSbm: true
              }
            ]
          },
          {
            id: null,
            status: 'installed', // "installed" || "commissioned" || "registered" || "incomplete" || "unlinked"
            customerId: null,
            customerEmail: 'j*****.d***@i***.com',
            productRange: {
              id: 'b932a2dc-75aa-4534-a72b-eeb56c6975d3',
              name:
                'Daikin Altherma air/water heatpump low temperature wallhung',
              imageUrl:
                'https://stage.static.daikin.marlon.be/uploads/images/catalog/product-range/e650e2b2-61e5-11e5-8dc8-005056981398/f4a0c338f5fce8d1458c56f8f3daf07f0eebccfd.jpg',
              category: '',
              categoryImageUrl: 'https://...'
            },
            siteId: '',
            commissioningCode: 'ABC3',
            installationDate: '2024-11-01',
            buildingDate: '2022-11-01',
            servicePartner: {
              id: 'string',
              email: 'user@example.com',
              company_name: 'string',
              full_name: 'string',
              website_url: 'string',
              address: {
                street: 'string',
                number: 'string',
                postal_code: 'string',
                city: 'string',
                country: 'string'
              },
              phone_number: 'string'
            },
            address: {
              street: 'JohnStreet',
              number: 42,
              box: null,
              postalCode: '65535',
              city: 'Location',
              country: 'BE'
            },
            units: [
              {
                type: 'lan_adapter',
                material: 'abc123',
                serial: '9876543',
                registeredOnSbm: false
              },
              {
                type: 'indoor',
                material: '000000',
                serial: '12345678',
                registeredOnSbm: false
              }
            ]
          },
          {
            id: null,
            status: 'installed', // "installed" || "commissioned" || "registered" || "incomplete" || "unlinked"
            customerId: null,
            customerEmail: 'j*****.d***@i***.com',
            productRange: {
              id: 'b932a2dc-75aa-4534-a72b-eeb56c6975d3',
              name:
                'Daikin Altherma air/water heatpump low temperature wallhung',
              imageUrl:
                'https://stage.static.daikin.marlon.be/uploads/images/catalog/product-range/e650e2b2-61e5-11e5-8dc8-005056981398/f4a0c338f5fce8d1458c56f8f3daf07f0eebccfd.jpg',
              category: '',
              categoryImageUrl: 'https://...'
            },
            siteId: '',
            commissioningCode: 'ABC3',
            installationDate: '2024-11-01',
            buildingDate: '2022-11-01',
            servicePartner: {
              id: 'string',
              email: 'user@example.com',
              company_name: 'string',
              full_name: 'string',
              website_url: 'string',
              address: {
                street: 'string',
                number: 'string',
                postal_code: 'string',
                city: 'string',
                country: 'string'
              },
              phone_number: 'string'
            },
            address: {
              street: 'JohnStreet',
              number: 42,
              box: null,
              postalCode: '65535',
              city: 'Location',
              country: 'nl'
            },
            units: [
              {
                type: 'lan_adapter',
                material: 'abc123',
                serial: '9876543',
                registeredOnSbm: false
              },
              {
                type: 'indoor',
                material: '000000',
                serial: '12345678',
                registeredOnSbm: false
              }
            ]
          }
        ],
        unknownUnits: [
          {
            type: 'indoor',
            material: '000000',
            serial: '12345678'
          }
        ],
        errors: []
      }
      const mockCases = {
        'multiple-installations': 0,
        'single-installation': 1,
        'no-installation': 2,
        'user-info': 3,
        'no-user-info': 4,
        'multiple-installations-missing-data': 5
      }
      const mockCase = 'single-installation'

      switch (mockCases[mockCase]) {
        case mockCases['no-installation']:
          mockData.installations = []
          break
        case mockCases['single-installation']:
          mockData.installations = [
            {
              id: null,
              status: 'commissioned', // "installed" || "commissioned" || "registered" || "incomplete" || "unlinked"
              customerId: null,
              customerEmail: 'j*****.d***@i***.com',
              productRange: {
                id: 'b932a2dc-75aa-4534-a72b-eeb56c6975d3',
                name:
                  'Daikin Altherma air/water heatpump low temperature wallhung',
                imageUrl:
                  'https://stage.static.daikin.marlon.be/uploads/images/catalog/product-range/e650e2b2-61e5-11e5-8dc8-005056981398/f4a0c338f5fce8d1458c56f8f3daf07f0eebccfd.jpg',
                category: '',
                categoryImageUrl: 'https://...'
              },
              siteId: '',
              commissioningCode: 'ABC3',
              installationDate: '2024-11-01',
              buildingDate: '2022-11-01',
              servicePartner: {
                id: 'string',
                email: 'user@example.com',
                company_name: 'string',
                full_name: 'string',
                website_url: 'string',
                address: {
                  street: 'string',
                  number: 'string',
                  postal_code: 'string',
                  city: 'string',
                  country: 'string'
                },
                phone_number: 'string'
              },
              address: {
                street: 'JohnStreet',
                number: 42,
                box: null,
                postalCode: '65535',
                city: 'Location',
                country: 'BE'
              },
              units: [
                {
                  type: 'lan_adapter',
                  material: 'abc123',
                  serial: '9876543',
                  registeredOnSbm: false
                },
                {
                  type: 'indoor',
                  material: '000000',
                  serial: '12345678',
                  registeredOnSbm: false
                }
              ]
            }
          ]
          break
        case mockCases['no-user-info']:
          mockData.customer.address = {
            country: 'BE'
          }
          break
        case mockCases['multiple-installations-missing-data']:
          mockData.installations = [
            {
              id: null,
              status: 'commissioned', // "installed" || "commissioned" || "registered" || "incomplete" || "unlinked"
              customerId: null,
              customerEmail: 'j*****.d***@i***.com',
              productRange: {
                id: 'b932a2dc-75aa-4534-a72b-eeb56c6975d3',
                name:
                  'Daikin Altherma air/water heatpump low temperature wallhung',
                imageUrl:
                  'https://stage.static.daikin.marlon.be/uploads/images/catalog/product-range/e650e2b2-61e5-11e5-8dc8-005056981398/f4a0c338f5fce8d1458c56f8f3daf07f0eebccfd.jpg',
                category: '',
                categoryImageUrl: 'https://...'
              },
              siteId: '',
              commissioningCode: 'ABC3',
              installationDate: null,
              buildingDate: null,
              servicePartner: null,
              address: null,
              units: [
                {
                  type: 'lan_adapter',
                  material: 'abc123',
                  serial: '9876543',
                  registeredOnSbm: false
                },
                {
                  type: 'indoor',
                  material: '000000',
                  serial: '12345678',
                  registeredOnSbm: false
                }
              ]
            },
            {
              id: null,
              status: 'commissioned', // "installed" || "commissioned" || "registered" || "incomplete" || "unlinked"
              customerId: null,
              customerEmail: 'j*****.d***@i***.com',
              productRange: {
                id: 'b932a2dc-75aa-4534-a72b-eeb56c6975d3',
                name:
                  'Daikin Altherma air/water heatpump low temperature wallhung',
                imageUrl:
                  'https://stage.static.daikin.marlon.be/uploads/images/catalog/product-range/e650e2b2-61e5-11e5-8dc8-005056981398/f4a0c338f5fce8d1458c56f8f3daf07f0eebccfd.jpg',
                category: '',
                categoryImageUrl: 'https://...'
              },
              siteId: '',
              commissioningCode: 'ABC3',
              installationDate: '2024-11-01',
              buildingDate: '2022-11-01',
              servicePartner: {
                id: 'string',
                email: 'climatronix@partner.com',
                company_name: 'ClimaTronix bvba',
                full_name: 'ClimaTronix',
                website_url: 'string',
                address: {
                  street: 'Honderedweg',
                  number: '10',
                  postal_code: '9230',
                  city: 'Wetteren',
                  country: 'België'
                },
                phone_number: 'string'
              },
              address: {
                street: 'JohnStreet',
                number: 42,
                box: null,
                postalCode: '65535',
                city: 'Location',
                country: 'BE'
              },
              units: [
                {
                  type: 'lan_adapter',
                  material: 'abc123',
                  serial: '9876543',
                  registeredOnSbm: false
                },
                {
                  type: 'indoor',
                  material: '000000',
                  serial: '12345678',
                  registeredOnSbm: false
                }
              ]
            }
          ]
          break
        case mockCases['multiple-installations']:
          // Do nothing yet
          break
      }
      console.log(
        '🚀 MOCKDATA: Making request to ' +
          ctx.$axiosMarlon?.defaults?.baseURL +
          url
      )
      console.log(`MOCKDATA - ${mockCase}: `, mockData)
      return mockData
    }
  }
}

export default function(ctx, inject) {
  const isContext = !!(ctx && inject)
  const _ctx = isContext ? ctx : Vue.prototype
  const _mockiOApi = mockiOApi(_ctx)
  Vue.prototype.$mockiOApi = _mockiOApi
  if (isContext) {
    ctx.$mockiOApi = _mockiOApi
    inject('mockiOApi', _mockiOApi)
  } else {
    return _mockiOApi
  }
}
